var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpTrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 4L12.1935 5.52667L8.94016 8.78L6.2735 6.11333L1.3335 11.06L2.2735 12L6.2735 8L8.94016 10.6667L13.1402 6.47333L14.6668 8V4H10.6668Z",
    fill: "#00B69B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpTrend);
export default __webpack_public_path__ + "static/media/UpTrend.197c30e5a3f382f8964338141fe34f3f.svg";
export { ForwardRef as ReactComponent };